export let events;
(function (events) {
  events["interaction"] = "interaction";
  events["usage"] = "usage";
  events["view"] = "view";
  events["commerceSpecialistsInteraction"] = "commerceSpecialistsInteraction";
})(events || (events = {}));